export const ENTRIES_PER_PAGE = 20;
export const TITLE_SUFFIX = " - Grand Paris Aménagement";
export const SITE_NAME = "Grand Paris Aménagement";
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
